import React, { useState } from "react";
import Layout from "../../Layout/Layout";
import DropshippingInterneLayout from "../components/DropshippingInterneLayout";
import ProviderMarketplaceBrowser from "./ProviderMarketplaceBrowser";
import SellerSourcingHistorySection from "../history/RecentlyViewedSwipers";

const DropshippingIn = ({ infoSource }) => {
  const [view, setView] = useState("grid");

  return (
    <Layout
      infoSource={infoSource}
      titleElakay="dropshippingIn"
      SliderPunShow={false}
      loading={false}
      outOffPage={false}
      {...infoSource?.allSettings?.layout}
      showFooter={true}
    >
      <DropshippingInterneLayout infoSource={infoSource}>
        <ProviderMarketplaceBrowser variant="dropshipping" view={view} setView={setView} />
        {/* Seller Sourcing History: after the main Dropshipping In tools (resume where you left off). */}
        <div className="dsi-page"><SellerSourcingHistorySection infoSource={infoSource} /></div>
      </DropshippingInterneLayout>
    </Layout>
  );
};

export default DropshippingIn;
